import { render, staticRenderFns } from "./MiniCart.vue?vue&type=template&id=04990305&scoped=true&"
import script from "./MiniCart.vue?vue&type=script&lang=js&"
export * from "./MiniCart.vue?vue&type=script&lang=js&"
import style0 from "./MiniCart.vue?vue&type=style&index=0&id=04990305&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04990305",
  null
  
)

export default component.exports